import Vue from 'vue'

import PortalForbidden from './components/403.vue'
import PortalNotFound from './components/404.vue'
import PortalPermissoes from './components/PortalPermissoes.vue'
import PortalListaVazia from './components/PortalListaVazia.vue'
import PortalCabecalho from './components/PortalCabecalho.vue'
import PortalRodape from './components/PortalRodape.vue'
import PortalBox from './components/PortalBox.vue'
import PortalPerfil from './components/PortalPerfil.vue'
import PortalLoading from './components/PortalLoading.vue'
import PortalLoadingSmall from './components/PortalLoadingSmall.vue'
import PortalFiltro from './components/PortalFiltro.vue'

Vue.component('portal-403', PortalForbidden)
Vue.component('portal-404', PortalNotFound)
Vue.component('portal-permissoes', PortalPermissoes)

Vue.component('portal-cabecalho', PortalCabecalho)
Vue.component('portal-rodape', PortalRodape)
Vue.component('portal-perfil', PortalPerfil)
Vue.component('portal-box', PortalBox)
Vue.component('portal-lista-vazia', PortalListaVazia)
Vue.component('portal-loading', PortalLoading)
Vue.component('portal-loading-small', PortalLoadingSmall)
Vue.component('portal-filtro-dropdown', PortalFiltro)

Vue.filter('truncate', function (value, length) {
  if (value.length < length) { return value }
  length = length - 3
  return value.substring(0, length) + '...'
})

Vue.filter('telefone', function (value) {
  return value.toString().replace(/[^0-9]/g, '').replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
})

Vue.filter('cpfcnpj', function (value) {
  if (value) {
    let digitos = value.toString().replace(/[^0-9]/g, '')
    if (digitos.length === 11) {
      return digitos.replace(/(\d{3})(\d{3})(\d{3})/, '$1.$2.$3-')
    }
    if (digitos.length === 14) {
      return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})/, '$1.$2.$3/$4-')
    }
  }
  return value
})

Vue.filter('moeda', function (int) {
  return parseFloat(int).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
})

const PortalVueComponents = {
  install (Vue, options) {
    Vue.prototype.$errorType = function (campo, errors, classeCss) {
      return errors.has(campo) ? 'is-danger' : classeCss
    }
    Vue.prototype.$clonar = function (obj) {
      return JSON.parse(JSON.stringify(obj))
    }
    Vue.prototype.$header = function () {
      if (options.cookie.get('token', {domain: options.dominio}) === null) {
        options.router.push('/login')
      }
      return {headers: {token: options.cookie.get('token'), versao: this.$sistema.versao()}}
    }
    Vue.prototype.$meses = function () {
      return ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    }
    Vue.prototype.$dias = function () {
      return ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
    }
    Vue.prototype.$URL = options.constantes.URL
    Vue.prototype.$C = options.constantes
    Vue.prototype.$cores = function () {
      return ['rgba(51, 102, 204, 0.7)',
        'rgba(220, 57, 18, 0.7)',
        'rgba(255, 153, 0, 0.7)',
        'rgba(16, 150, 24, 0.7)',
        'rgba(153, 0, 153, 0.7)',
        'rgba(59, 62, 172, 0.7)',
        'rgba(0, 153, 198, 0.7)',
        'rgba(221, 68, 119, 0.7)',
        'rgba(102, 170, 0, 0.7)',
        'rgba(184, 46, 46, 0.7)',
        'rgba(49, 99, 149, 0.7)',
        'rgba(153, 68, 153, 0.7)',
        'rgba(34, 170, 153, 0.7)',
        'rgba(170, 170, 17, 0.7)',
        'rgba(102, 51, 204, 0.7)',
        'rgba(230, 115, 0, 0.7)',
        'rgba(139, 7, 7, 0.7)',
        'rgba(50, 146, 98, 0.7)',
        'rgba(85, 116, 166, 0.7)',
        'rgba(59, 62, 172, 0.7)']
    }
    Vue.prototype.$sistema = {
      nome () {
        return options.nome
      },
      icone () {
        return options.icone
      },
      perfil () {
        return options.perfil
      },
      versao () {
        return options.versao
      }
    }
    Vue.prototype.$acessar = function () {
      if (options.cookie) {
        let token = options.cookie.get('token', {domain: options.dominio})
        if (token === null) {
          options.router.push('/login')
        } else {
          return true
        }
      } else {
        options.router.push('/403')
      }
      return false
    }
    Vue.prototype.$salvarPermissoes = function (permissoes) {
      if (options.cookie) {
        let token = options.cookie.get('token', {domain: options.dominio})
        if (token !== null) {
          localStorage.setItem(options.nome + '.p.' + token, permissoes)
        }
      }
    }
    Vue.prototype.$air = {
      checkLogado () {
        if (options.cookie.get('token') !== null) {
          options.router.push('/dashboard')
        }
        if (options.cookie.get('A3_COD') === null || options.cookie.get('A3_NOME') === null) {
          options.router.push('/login')
        }
        return this.usuarioLogado()
      },
      usuarioLogado () {
        return {
          nome: options.cookie.get('A3_NOME'),
          codigo: options.cookie.get('A3_COD'),
          token: options.cookie.get('token')
        }
      },
      checkAuth () {
        let token = options.cookie.get('token', {domain: options.dominio})
        if (token === null) {
          options.router.push('/login')
        }
      },
      autenticar (token, representante) {
        options.cookie.set('token', token, {expires: options.tempo, domain: options.dominio})
        options.cookie.set('A3_NOME', representante.A3_NOME, {expires: options.tempo, domain: options.dominio})
        options.cookie.set('A3_COD', representante.A3_COD, {expires: options.tempo, domain: options.dominio})
        options.router.push('/dashboard')
      },
      sair () {
        options.cookie.delete('token', {domain: options.dominio})
        options.cookie.delete('A3_NOME', {domain: options.dominio})
        options.cookie.delete('A3_COD', {domain: options.dominio})
        options.router.push('/login')
      }
    }
    Vue.prototype.$removeDuplicatesBy = function (keyFn, array) {
      let mySet = new Set()
      return array.filter(function (x) {
        let key = keyFn(x)
        let isNew = !mySet.has(key)
        if (isNew) mySet.add(key)
        return isNew
      })
    }
    Vue.prototype.$valorDesconto = function (percentualDesconto, valor) {
      if (!percentualDesconto || percentualDesconto === 0) {
        return 0
      }
      return (percentualDesconto / 100) * valor
    }
    Vue.prototype.$valorAposDesconto = function (percentualDesconto, valor) {
      if (!percentualDesconto || percentualDesconto === 0) {
        return valor
      }
      if (valor >= 0 && valor < 1) {
        return valor - (percentualDesconto / 100)
      } else {
        return (1 - (percentualDesconto / 100)) * valor
      }
    }
    Vue.prototype.$percentualDesconto = function (valorDesconto, valorBruto) {
      if (valorBruto === 0) return 0
      let perc
      perc = parseFloat((valorDesconto * 100) / valorBruto).toFixed(2)
      if (perc === parseFloat(100.00).toFixed(2)) {
        return 99.99
      }
      return perc
    }
    Vue.prototype.$converterDecimal = function (valor) {
      var v = parseFloat(valor)
      var v2 = v.toFixed(2)
      return v2
    }
    Vue.prototype.$normalizar = function (valor, maiusculo, minusculo) {
      if (!valor) return ''

      valor = valor.toString()

      if (maiusculo) {
        valor = valor.toLocaleUpperCase()
      } else if (minusculo) {
        valor = valor.toLocaleLowerCase()
      }
      valor = valor.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'A')
      valor = valor.replace(new RegExp('[ÉÈÊ]', 'gi'), 'E')
      valor = valor.replace(new RegExp('[ÍÌÎ]', 'gi'), 'I')
      valor = valor.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'O')
      valor = valor.replace(new RegExp('[ÚÙÛ]', 'gi'), 'U')
      valor = valor.replace(new RegExp('[Ç]', 'gi'), 'C')
      valor = valor.replace(/[^a-z&0-9^\s]/gi, '')
      valor = valor.replace(/\s{2,}/gi, ' ')
      return valor
    }
  }
}
export default PortalVueComponents



// WEBPACK FOOTER //
// ./src/portal-vue-components.js